// extracted by mini-css-extract-plugin
export default {"logout":"Logout-module__logout__EMbjD","icon":"Logout-module__icon__T+PWZ"};